import React, { Component } from 'react';
import { dAPI } from 'appSrc/api';
import { PrimaryButton } from 'appSrc/components/UI';
import LoadingReplace from 'appSrc/components/Shards/Loading/LoadingReplace';
import AllArticlesTable from './Table';
import ContentSearchModal from 'appSrc/AdminPanel/components/ContentSearchModal';
import style from './styles/style.module.css';

class AssociatedContentTab extends Component {
    state = {
        addingAssociatedContent: false,
    }
    addAssociatedContent = ( content ) => {
        let aId = this.props.id;
        let bId = content.id;

        return dAPI.post( `/admin/content/${ aId }/associated/${ bId }` )
        .then( () => {
            this.props.onUpdate();
        } );
    }
    removeAssociatedContent = ( content ) => {
        let aId = this.props.id;
        let bId = content.id;

        return dAPI.delete( `/admin/content/${ aId }/associated/${ bId }` )
        .then( () => {
            this.props.onUpdate();
        } );
    }
    render() {
        const { fetching, content } = this.props;

        if( fetching ) {
            return (
                <section className={ style.tab }>
                    <LoadingReplace />
                </section>
            );
        }

        return (
            <section className={ style.tab }>
                <div>
                    <PrimaryButton label='Add+' onClick={ () => { this.setState( { addingAssociatedContent: true } ); } } />
                </div>
                <AllArticlesTable content={ content } deleteConnection={ this.removeAssociatedContent } />
                { this.state.addingAssociatedContent &&
                    <ContentSearchModal closeModal={ () => { this.setState( { addingAssociatedContent: false } ); } }
                    onSubmit={ this.addAssociatedContent } existingContent={ content } />
                }
            </section>
        );
    }
}
AssociatedContentTab.defaultProps = {
    onUpdate: () => {},
};


export default AssociatedContentTab;
